<template>
  <div
    v-bind:class="{
      'justify-content-between': between,
      'justify-content-end': end,
      'border-top': containerTopBorder,
      'mt-5': marginTop,
      'mb-5': marginBottom,
    }"
    class="d-flex flex-wrap pt-4"
  >
    <b-button
      v-if="!hide_secondary"
      @click="handleSecondaryClick($event)"
      :variant="secondaryVariant"
      :size="buttonSize"
      class="mx-auto mx-md-0"
    >{{ get_secondary_text }}</b-button>

    <b-button
      v-if="!hide_primary"
      :type="primaryType"
      :variant="primaryVariant"
      :size="buttonSize"
      class="mx-auto mt-3 mt-md-0 ml-md-5 mr-md-0"
      @click="handlePrimaryClick($event)"
    >{{ get_primary_text }}</b-button>
  </div>
</template>

<script>
// para cuando tengamos botón back en el header, colocar
// esto en el botón secundario y añadir props
// que indique si debe o no ocultarse en pantallas
// pequeñas:
// class="d-none d-sm-none d-md-block"

export default {
  components: {},
  props: {
    // colocar los botones a los extremos derecho e izquierdo
    between: {
      type: Boolean,
      default: false,
    },
    // coloca los botones al final
    end: {
      type: Boolean,
      default: false,
    },
    // esconder botón primario
    hide_primary: {
      type: Boolean,
      default: false,
    },
    // esconder botón secundario
    hide_secondary: {
      type: Boolean,
      default: false,
    },
    // texto del botón primario
    primary_text: {
      type: String,
      default: undefined,
    },
    // texto del botón secundario
    secondary_text: {
      type: String,
      default: undefined,
    },
    // ruta del botón primario al hacer click
    // se ignore con primary-type='submit'
    primary_to: {
      type: Object,
      default: function() {
        return { name: "home" };
      },
    },
    prevent_primary_default: {
      type: Boolean,
      default: false,
    },
    // ruta del botón secundario al hacer click
    secondary_to: {
      type: Object,
      default: undefined,
    },
    prevent_secondary_default: {
      type: Boolean,
      default: false,
    },
    // tipo de botón
    primaryType: {
      type: String,
      default: "button",
    },
    // borde superior NO DEL BOTÓN, sino del contenedor
    containerTopBorder: {
      type: Boolean,
      default: true,
    },
    // margen superior
    marginTop: {
      type: Boolean,
      default: true,
    },
    marginBottom: {
      type: Boolean,
      default: true,
    },
    buttonSize: {
      type: String,
      default: "lg",
    },
    secondaryVariant: {
      type: String,
      default: "group-secondary-b",
    },
    primaryVariant: {
      type: String,
      default: "group-primary-b",
    },
  },
  data() {
    return {};
  },
  computed: {
    get_primary_text() {
      if (this.primary_text) {
        return this.primary_text;
      }
      return this.$t("button_group.primary_text");
    },
    get_secondary_text() {
      if (this.secondary_text) {
        return this.secondary_text;
      }
      return this.$t("button_group.secondary_text");
    },
  },
  mounted() {},
  methods: {
    handleSecondaryClick(evt) {
      if (this.secondary_to) {
        return this.$router.push(this.secondary_to);
      }
      if (!this.prevent_secondary_default) {
        return this.$router.go(-1);
      }
      this.$emit("secondary-click", evt);
    },
    handlePrimaryClick(evt) {
      if (
        !this.prevent_primary_default &&
        this.primary_to &&
        this.primaryType != "submit"
      ) {
        return this.$router.push(this.primary_to);
      }
      this.$emit("primary-click", evt);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        button_group: {
          secondary_text: "Return",
          primary_text: "Go to home",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
